import 'firebaseui/dist/firebaseui.css';

import { GoogleAuthProvider } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import { useEffect } from 'react';

import { setInternalAuthRequired } from '../../app/apiScreenSlice';
import { useImpState } from '../../app/hooks';
import { auth } from '../../firebase/firebase';

//! this is unused but seems like it might be useful, commenting out to keep linter happy
// const uiConfig = {
//   signInFlow: 'popup',
//   signInOptions: [GoogleAuthProvider.PROVIDER_ID],
//   callbacks: {
//     signInSuccessWithAuthResult: () => false,
//   },
// };

function FirebaseLogin() {
  const { dispatch } = useImpState();

  useEffect(() => {
    // Initialize the FirebaseUI Widget using Firebase.
    const ui =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

    ui.start('#firebaseui-auth-container', {
      signInFlow: 'popup',
      signInOptions: [GoogleAuthProvider.PROVIDER_ID],
      callbacks: {
        signInSuccessWithAuthResult: function (_authResult, _redirectUrl) {
          // Handle the result
          dispatch(setInternalAuthRequired(false));
          return true;
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <link
        type="text/css"
        rel="stylesheet"
        href="https://www.gstatic.com/firebasejs/ui/6.0.1/firebase-ui-auth.css"
      />
      <div id="firebaseui-auth-container" />
    </>
  );
}

export default FirebaseLogin;
